import styled from 'styled-components';

import { Headline } from '@xing-com/typography';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 100%;

  .industry {
    width: 100%;
    display: block;
    max-width: 50%;
    padding: var(--spaceL);
    color: var(--xdlColorText);
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
    @media (min-width: 740px) {
      width: 100%;
      max-width: calc(100% / 3);
    }
  }
`;

export const IndustriTitle = styled(Headline)<$TSFixMe>`
  margin-top: var(--spaceXL);
  margin-bottom: var(--spaceXXL);
`;
